module.exports = __webpack_public_path__ + "img/BE0836324003.aef1a503.png";